import Swiper from 'swiper/js/swiper';
import '../../../js/utils/polyfill-nodeList-forEach'; // lt IE 12
import addToDataLayer from '../../../js/utils/dataLayer';

export default class QuickLinksViewModel {
    constructor(module) {
        this.module = module;
        this.swiper = null;
        this.isSwiping = false;
        this.hookSlider();
        this.trackQuickLinks();
    }

    hookSlider() {
        this.initSwiper();
        window.addEventListener(
            'resize',
            () => this.initSwiper(),
            this
        );
    }

    destroySwiper() {
        if (this.swiper !== null) {
            this.swiper.destroy();
            this.swiper = null;
            const row = this.module.querySelector('.flex');
            const columns = row.querySelectorAll('.quick-links__item');
            const pagination = this.module.querySelector('.swiper-pagination');

            row.classList.remove('swiper-wrapper');
            columns.forEach(column => column.classList.remove('swiper-slide'));
            pagination.style.display = 'none';
        }
    }

    initSwiper() {
        if (window.innerWidth < 768) {
            if (this.swiper === null) {
                const row = this.module.querySelector('.flex');
                const columns = row.querySelectorAll('.quick-links__item');

                row.classList.add('swiper-wrapper');
                columns.forEach(column => column.classList.add('swiper-slide'));
            }

            const pagination = this.module.querySelector('.swiper-pagination');
            pagination.style.display = 'block';

            this.swiper = new Swiper('.quick-links .swiper-container', {
                direction: 'horizontal',
                loop: false,
                init: true,
                slidesPerView: window.innerWidth < 500 ? 2 : 3,
                slidesPerGroup: window.innerWidth < 500 ? 2 : 3,
                spaceBetween: 30,
                initialSlide: 0,
                pagination: {
                    el: '.quick-links .swiper-pagination'
                }
            });
        } else {
            this.destroySwiper();
        }
    }

    trackQuickLinks() {
        const quickLinks = this.module.querySelectorAll('.quick-links__item__link');
        if (quickLinks) {
            quickLinks.forEach(quickLink => {
                quickLink.addEventListener('click', () => {
                    addToDataLayer({
                        event: 'link.click',
                        linkName: unescape(quickLink.querySelector('.quick-links__item__text__headline').innerHTML).trim(),
                        linkType: 'quicklink',
                    });
                });
            });
        }
    }

    static init(module) {
        new QuickLinksViewModel(module);
    }

}

window.SAU = window.SAU || {};
window.SAU.quickLinks = QuickLinksViewModel;
